import { useFormik } from "formik"
import validationSchema from "../validationSchema"
import type { SenderForm, Sender } from "@/types/entities/sender"

const toIdList = (values?: string[]) => values || []

export const useSenderForm = ({
  data,
  onSubmit,
}: {
  data?: Sender
  onSubmit: (values: SenderForm) => void
}) => {
  const formik = useFormik<SenderForm>({
    initialValues: data
      ? {
          ...data,
          bindingMode: data.allowedDomains?.length ? "domains" : "mailboxes",
          allowedEmailAddresses: toIdList(data.allowedEmailAddresses),
          allowedDomains: toIdList(data.allowedDomains),
          address: {
            address1: "",
            address2: "",
            city: "",
            state: "",
            zipCode: "",
            completeAddress: "",
            postalCode: "",
            province: "",
            ...data.address,
            countryCode: data.address.countryCode ?? "US",
          },
        }
      : {
          email: "",
          tag: "",
          address: {
            address1: "",
            address2: "",
            city: "",
            countryCode: "",
            state: "",
            zipCode: "",
            completeAddress: "",
            postalCode: "",
            province: "",
          },
          titles: [""],
          companies: [""],
          websites: [""],
          allowedEmailAddresses: [],
          allowedDomains: [],
          bindingMode: "mailboxes",
          firstName: "",
          lastName: "",
          phoneNumber: "",
        },
    enableReinitialize: true,
    validationSchema,
    onSubmit,
  })
  return formik
}
